declare namespace $ {

	type $mol_button_major__title_shm_hitalama_guide_editor_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_guide_editor_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['dirty'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_guide_editor_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_guide_editor_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_editor_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_guide_editor_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__question_shm_hitalama_guide_editor_7 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['question'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_guide_editor_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['remove'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_button_minor__hint_shm_hitalama_guide_editor_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_editor_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_guide_editor_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__value_shm_hitalama_guide_editor_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_guide_editor_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_guide_editor_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['Name_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__dictionary_shm_hitalama_guide_editor_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['folder_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_guide_editor_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['parent'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_labeler__title_shm_hitalama_guide_editor_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_guide_editor_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['Parent_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__value_shm_hitalama_guide_editor_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['content_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_labeler__title_shm_hitalama_guide_editor_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_guide_editor_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['Text_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_status__status_shm_hitalama_guide_editor_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_editor['status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	export class $shm_hitalama_guide_editor extends $mol_page {
		dirty( ): boolean
		save( next?: any ): any
		Save( ): $mol_button_major
		cancel( next?: any ): any
		Cancel( ): $mol_button_minor
		remove( next?: any ): any
		Delete( ): $shm_confirm_delete
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		name( next?: string ): string
		Name_input( ): $mol_string
		Name( ): $mol_labeler
		folder_options( ): Record<string, any>
		parent( next?: string ): string
		Parent_input( ): $mol_select
		Parent( ): $mol_labeler
		content_text( next?: string ): string
		Text_input( ): $mol_textarea
		Body_text( ): $mol_labeler
		status( ): string
		Status( ): $mol_status
		title( ): string
		catalog( ): $shm_hitalama_guide_catalog
		id( ): string
		opened( next?: boolean ): boolean
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map